import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	createLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	createLabel: {
		id: 'native-issue-table.ui.row.before-first-cell.sibling-issue-create-button.create-label',
		defaultMessage: 'Create',
		description: 'Label shown for the button to create an item.',
	},
});
export default messages;
